import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/.pnpm/next@15.4.11_react-dom@19.1.2_react@19.1.2__react@19.1.2_sass@1.103.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/.pnpm/next@15.4.11_react-dom@19.1.2_react@19.1.2__react@19.1.2_sass@1.103.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/src/app/(frontend)/(homepage)/_components/TestimonialsRow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/home/vsts/work/1/s/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BuyDriveButton"] */ "/home/vsts/work/1/s/src/components/BuyDriveButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DiscoverDriveButton"] */ "/home/vsts/work/1/s/src/components/DiscoverDriveButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/home/vsts/work/1/s/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/home/vsts/work/1/s/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandWordmark"] */ "/home/vsts/work/1/s/src/components/ui/BrandWordmark.tsx");
